import { render, staticRenderFns } from "./InfoBoxSalary.vue?vue&type=template&id=c3a242e6&scoped=true&"
import script from "./InfoBoxSalary.vue?vue&type=script&lang=js&"
export * from "./InfoBoxSalary.vue?vue&type=script&lang=js&"
import style0 from "./InfoBoxSalary.vue?vue&type=style&index=0&id=c3a242e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3a242e6",
  null
  
)

export default component.exports